import Spinner from "../components/common/spinner";

const Page404 = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "grid",
        placeItems: "center",
        textAlign: "center",
      }}
    >
      <h4>Not Found</h4>
    </div>
  );
};

export default Page404;
